/**
 * 教师端学院管理、班级管理、学生信息库相关API
 * Teacher Subject Category API
 */
import request from '@/utils/request'

// 获取学院列表
/**
 * @param {Object} data
 * @param {String} data.schoolId 当前登录学校id
 * @param {String} data.pageNum
 * @param {String} data.pageSize
 * @param {String} data.name
 * @param {String} data.allow
 * @returns 
 */
export function getTeacherCollegeList(data) {
  return request({
    url: '/school/yee_college_list',
    method: 'post',
    data
  })
}

// 添加学院
/**
 * 传入参数为 form-data
 * @param {Object} data
 * @param {String} data.allow 是否启用
 * @param {String} data.name 学院名称
 * @param {String} data.schoolId 当前登录学校id
 * @returns 
 */
export function addTeacherCollegeList(data) {
  return request({
    url: '/school/yee_college_add',
    method: 'post',
    data
  })
}

// 更新修改学院
// 也可实现启用禁用（修改其中allow）
/**
 * 传入参数为 form-data
 * @param {Object} data
 * @param {String} data.id 学院id
 * @param {String} data.allow 是否启用
 * @param {String} data.name 学校名称
 * @param {String} data.schoolId 当前登录学校id
 * @returns 
 */
export function updateTeacherCollegeList(data) {
  return request({
    url: '/school/yee_college_update',
    method: 'post',
    data
  })
}

// 删除学院
/**
 * @param {String} params.id 学院id
 * @param {String} params.schoolId 当前登录学校id
 * @returns 
 */
export function deleteTeacherCollegeList(params) {
  return request({
    url: '/school/yee_college_delete',
    method: 'get',
    params
  })
}

// ==================== 学生信息库(学生账号管理)相关接口 ====================

// 获取学生信息列表(兼查询功能)
/**
 * 传入参数为 form-data
 * @param {Object} data
 * @param {String} data.pageNum  
 * @param {String} data.pageSize
 * @param {String} data.schoolId 当前登录学校 id
 * @param {String} data.name 姓名
 * @param {String} data.idCard 身份证
 * @param {String} data.number 学号
 * @param {String} data.gender 性别
 * @param {String} data.classId 班级 Id
 * @param {String} data.collegeId 学院 ID
 * @param {String} data.entryYear 注册年份
 * @returns 
 */
export function getTeacherStudentList(data) {
  return request({
    url: '/school/yee_student_list',
    method: 'post',
    data
  })
}

/**
 * 查看学生详情
 * 传入参数为 form-data
 * @param {Object} data
 * @param {String} data.id 学生id
 * @param {String} data.schoolId 当前登录学校id
 * @returns 
 */
export function getTeacherStudentDetailInfo(data) {
  return request({
    url: '/school/yee_student_info',
    method: 'get',
    params:data
  })
}

// 更新修改学生信息
/**
 * 传入参数为 JSON
 * @param {Object} data
 * @param {String} data.id 学生id
 * @param {String} data.schoolId 当前登录学校id
 * @param {String} data.name 学生姓名
 * @returns 
 */
export function updateTeacherStudentDetailInfo(data) {
  return request({
    url: '/school/yee_student_update',
    method: 'post',
    data
  })
}

// 删除学生信息
/**
 * @param {String} params.id 学生id
 * @param {String} params.schoolId 当前登录学校id
 * @returns 
 */
export function deleteTeacherStudentDetailInfo(params) {
  return request({
    url: '/school/yee_student_delete',
    method: 'get',
    params
  })
}

/**
 * 模糊查询学生
 * 传入参数为 JSON
 * @param {Object} data
 * @param {String} data.pageNum 
 * @param {String} data.pageSize 
 * @param {String} data.name 学生姓名
 * @param {String} data.idCard 身份证
 * @param {String} data.schoolId 当前登录学校id
 * @param {String} data.number  学号
 * @param {String} data.gender  性别
 * @param {String} data.classId  班级ID
 * @param {String} data.collegeId  学院ID
 * @param {String} data.entryYear  注册年份
 * @returns 
 */
export function searchTeacherStudentDetailInfo(data) {
  return request({
    url: '/school/yee_student_search',
    method: 'post',
    data
  })
}

/**
 * 学生重置随机密码(单个)
 * 传入参数为 form-data
 * @param {Object} data
 * @param {String} data.id 
 * @param {String} data.schoolId 当前登录学校id
 * @returns 
 */
export function resetTeacherStudentpPassword(data) {
  return request({
    url: '/school/yee_stu_pwd_random',
    method: 'get',
    params:data
  })
}

/**
 * 学生重置随机密码(多个、多选重置)
 * 传入参数为 form-data
 * @param {Object} data
 * @param {String} data.number （后端接收格式为 List<Integer> ）
 * @param {String} data.schoolId 当前登录学校id
 * @returns 
 */
export function multipleResetTeacherStudentpPassword(data) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key])
    }
  })
  return request({
    url: '/school/yee_stu_pwd_reset',
    method: 'post',
    data: formData
  })
}

// 添加学生（学生信息库）
/**
 * POST /school/yee_student_add
 * 传入参数为 JSON
 * @param {Object} data 学生信息对象
 * @returns {Promise}
 */
export function addTeacherStudent(data) {
  return request({
    url: '/school/yee_student_add',
    method: 'post',
    data
  })
}

// 批量导出学生数据
/**
 * POST /school/yee_stu_export
 * @param {Object} data
 * @param {String|Number} data.schoolId 学校ID
 * @param {String} data.entryYear 学生年级
 * @param {String} data.keyword 姓名或学号
 * @param {String} data.idCard 身份证
 * @param {String} data.gender 性别
 * @param {String} data.classId 班级ID
 * @param {String} data.collegeId 学院ID
 * @returns {Promise}
 */
export function exportTeacherStudents(data) {
  return request({
    url: '/school/yee_stu_export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 批量导入学生
/**
 * POST /school/yee_stu_import
 * 传入参数为 form-data（包含文件）
 * @param {Object} payload
 * @param {String|Number} payload.schoolId 学校ID
 * @param {File} payload.file 学生导入文件（xls/xlsx）
 * @returns {Promise}
 */
export function importTeacherStudents(payload) {
  const formData = new FormData()
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) formData.append(k, v)
  })
  return request({
    url: '/school/yee_stu_import',
    method: 'post',
    data: formData
  })
}

// ==================== 班级管理相关接口 ====================

// 添加班级
/**
 * @param {Object} data
 * @param {Number} data.schoolId 学校ID
 * @param {String} data.name 班级名称
 * @param {Number} data.collegeId 学院ID
 * @param {Number} data.allow 是否启用 (0-禁用, 1-启用)
 * @param {Number} data.entryYear 入学年份
 * @returns 
 */
export function addTeacherClass(data) {
  return request({
    url: '/school/yee_class_add',
    method: 'post',
    data
  })
}

// 查询班级列表
/**
 * @param {Object} params
 * @param {String} params.schoolId 学校ID
 * @param {String} params.pageNum 页码
 * @param {String} params.pageSize 每页大小
 * @returns 
 */
export function getTeacherClassList(params) {
  return request({
    url: '/school/yee_class_list',
    method: 'get',
    params
  })
}

// 班级详情（通过id查询）
/**
 * @param {Object} params
 * @param {String} params.schoolId 学校ID
 * @param {String} params.id 班级ID
 * @returns 
 */
export function getTeacherClassInfoById(params) {
  return request({
    url: '/school/yee_class_info',
    method: 'get',
    params
  })
}

// 修改班级信息
/**
 * @param {Object} data
 * @param {Number} data.schoolId 学校ID
 * @param {Number} data.id 班级ID
 * @param {String} data.name 班级名称
 * @param {Number} data.entryYear 入学年份
 * @param {Number} data.allow 是否启用 (0-禁用, 1-启用)
 * @returns 
 */
export function updateTeacherClass(data) {
  return request({
    url: '/school/yee_class_update',
    method: 'post',
    data
  })
}

// 删除班级
/**
 * @param {Object} params
 * @param {String} params.schoolId 学校ID
 * @param {String} params.id 班级ID
 * @returns 
 */
export function deleteTeacherClass(params) {
  return request({
    url: '/school/yee_class_delete',
    method: 'get',
    params
  })
}

// 条件查询班级
/**
 * @param {Object} data
 * @param {Number} data.schoolId 学校ID
 * @param {Number} data.pageNum 页码
 * @param {Number} data.pageSize 每页大小
 * @param {String} data.name 班级名称(模糊查询)
 * @param {Number} data.allow 是否启用 (0-禁用, 1-启用)
 * @param {Number} data.collegeId 学院id
 * @returns 
 */
export function searchTeacherClass(data) {
  return request({
    url: '/school/yee_class_search',
    method: 'post',
    data
  })
}

// 禁用/启用班级
/**
 * @param {Object} params
 * @param {String} params.schoolId 学校ID
 * @param {String} params.id 班级ID
 * @returns 
 */
export function toggleTeacherClassStatus(params) {
  return request({
    url: '/school/yee_class_lock',
    method: 'get',
    params
  })
}


